import { Component, OnInit } from '@angular/core';
import { environment } from '@env';
import { faCopyright } from '@fortawesome/free-regular-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { APIWebService } from '@shared/services/api-web.service';

@Component({
  selector: 'fc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  faPhone = faPhone;
  faEnvelope = faEnvelope;
  faCopyright = faCopyright;
  facebookUrl = environment.facebookUrl;
  instagramUrl = environment.instagramUrl;

  paymentMethod: any[] = [
    {
      image: 'happy-pay.png',
      alt: 'Happy Pay',
    },
    {
      image: 'mastercard.png',
      alt: 'Mastercard',
    },
    {
      image: 'visa.png',
      alt: 'Visa',
    },
    {
      image: 'bankdeposit.png',
      alt: 'Bank Deposit',
    },
    {
      image: 'cod.png',
      alt: 'Cash on Delivery',
    },
    {
      image: 'paypal.png',
      alt: 'Paypal',
    },
  ];

  shippingMethod: any[] = [
    {
      img: 'dhl.webp',
      alt: 'DHL',
    },
    {
      img: 'aramex.webp',
      alt: 'Aramex',
    },
    {
      img: 'sns.webp',
      alt: 'SNS',
    },
  ];

  socialMedia: any[] = [
    {
      link: environment.instagramUrl,
      image: '/assets/images/social-media/instagram.webp',
      alt: 'instagram',
      name: 'happybeautysg',
    },
    {
      link: environment.facebookUrl,
      image: '/assets/images/social-media/facebook.webp',
      alt: 'facebook',
      name: 'Happybeauty Singapore',
    },
  ];
  phoneNumber = '';
  constructor(private apiWebService: APIWebService) {
    this.apiWebService.getLocalJsonChat().subscribe((data: any) => {
      this.phoneNumber = data.whatsapp.number;
    });
  }

  ngOnInit(): void {}
}
